import React from 'react'
import { Menu, Tag } from 'antd'
import styles from '../TopBar.module.scss'
import { useComponentLocale } from '../../hooks/useComponentLocale'
import TierTag from '../../components/freeTags/TierTag'
import { history } from '../../_history'
import { ViewerIcon } from '../../helpers/icons'

const { ItemGroup, SubMenu, Item } = Menu

function ViewSubMenu({ librariesResponse, viewLocale, getIconStyle, ...props }) {
	const getLocale = useComponentLocale()

	const libs = librariesResponse?.libraries ?? []

	const gtoSolutionsLocale = getLocale({ component: 'common', section: 'gto_solutions' })

	const goToLib = (link) => {
		history.push(link)
	}

	const renderSubMenus = (children, level, library) => {
		const recursRender = (children, level, isPostflop) => {
			if (level === 'spots') {
				return children.map((item) => {
					const spot = library.spots.find((spot) => spot.spot_id === item)
					const link = `/viewer?id=${spot?.spot_id}&q=${spot?.default_stack}`
					const spotName = spot?.spot
					const spotRange = `${spot?.min_stack} - ${spot?.max_stack}`
					const key = `viewer_${spot?.spot_id}`
					let spotWithPostflop = isPostflop && (spot.postflop_type === 'partially' || spot.postflop_count > 0)

					return (
						<Item key={key}>
							<button
								onClick={() => goToLib(link)}
								className={styles.playButton}
								style={{
									justifyContent: isPostflop ? 'flex-start' : 'space-between',
								}}
							>
								<span>{spotName}</span>

								<div>
									<Tag>{spotRange}</Tag>

									{spotWithPostflop ? (
										<Tag
											color='rgba(115, 130, 168, 0.2)'
											style={{ border: '1px solid rgba(115, 130, 168, 0.3)', marginLeft: 5 }}
										>
											Postflop
										</Tag>
									) : null}
								</div>
							</button>
						</Item>
					)
				})
			}

			if (children) {
				return children.map((spotGroup) => (
					<SubMenu
						title={
							<div className={styles.topBarViewItemContainer}>
								{spotGroup.name}

								{spotGroup.has_postflop ? (
									<Tag
										color='rgba(115, 130, 168, 0.2)'
										style={{ border: '1px solid rgba(115, 130, 168, 0.3)', marginLeft: 5 }}
									>
										Postflop
									</Tag>
								) : null}
							</div>
						}
						key={spotGroup.name}
					>
						{recursRender(spotGroup.children, spotGroup.level, spotGroup.has_postflop)}
					</SubMenu>
				))
			}
		}

		return recursRender(children, level)
	}

	return (
		<SubMenu
			title={
				<div className={styles.topBarLinks}>
					<ViewerIcon />
					<span className={styles.menuTitle}>{viewLocale}</span>
				</div>
			}
			key='viewer'
			{...props}
			className={styles.menuItem}
		>
			<ItemGroup title={gtoSolutionsLocale}>
				{libs.map((library) => {
					const tier = library?.tiers.find(({ tier_id }) => tier_id === library.active_tier)

					return (
						<SubMenu
							title={
								<div className={styles.topBarViewItemContainer}>
									{library.library_name} {tier?.subscriptions && <TierTag tierName={tier?.tier_name} />}
								</div>
							}
							key={library.library_name}
						>
							{renderSubMenus(library.navigate?.structure?.children, library.navigate?.structure?.level, library)}
						</SubMenu>
					)
				})}
			</ItemGroup>
		</SubMenu>
	)
}

export default ViewSubMenu
